import React, { useEffect, useState } from "react";

enum AnimationTypes {
  ComeInFromRight = "ComeInFromRight",
  ShiftRight = "ShiftRight"
}

type FindSearchPanelProps = {
  onClose: () => void;
  placeholder: string
  shiftedItem: any;
  onDialogOpen: (object: any) => void;
};

const FindSearchPanel: React.FC<FindSearchPanelProps> = ({ onClose, placeholder, shiftedItem, onDialogOpen }) => {
  const [Animation, setAnimation] = useState<string>(AnimationTypes.ComeInFromRight);
  const [inputValue, setInputValue] = useState<string>('');
  const [showError, setShowError] = useState<boolean>(false);


  useEffect(() => {
    setAnimation(AnimationTypes.ComeInFromRight);
  }, []);

  useEffect(() => {
    if (Animation === AnimationTypes.ShiftRight) {
      const timeout = setTimeout(() => {
        onClose();
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [Animation, onClose]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
        handleFindClick();
    }
};
 
  const handleFindClick = () => {
    if (inputValue.trim() === '') 
    {
      setShowError(true);
    } 
    else 
    {
      setShowError(false);
      const newObject = {
        key: shiftedItem?.Id,
        title: "Search results for - " + inputValue,
        Id: shiftedItem?.Id,
        Links: {
          POST: [{
            Url: `Object/${shiftedItem?.Id}`,
            Template: shiftedItem?.StoredProcParams?.replaceAll("{searchValue}", inputValue),
            Rel: "Object",
            ResponseHints: null
          }],
          GET: shiftedItem?.Link?.GET || []
        },
        StoredProcParams: shiftedItem?.StoredProcParams?.replaceAll("{searchValue}", inputValue),
        Name: shiftedItem?.content,
        Warning: shiftedItem?.Warning,
        MessageResults: shiftedItem?.MessageResults,
        className: shiftedItem?.className
      };

      if (inputValue.indexOf("'") !== -1) {
        const escapedInput = inputValue.replace(/'/g, "''''");
        newObject.StoredProcParams = shiftedItem?.StoredProcParams?.replaceAll("{searchValue}", escapedInput);
        if (newObject.Links?.POST?.[0]?.Template) {
          newObject.Links.POST[0].Template = shiftedItem?.StoredProcParams?.replaceAll("{searchValue}", escapedInput);
        }
      }
      onDialogOpen(newObject);
      setAnimation(AnimationTypes.ShiftRight); // This will call onClose via useEffect

    }
  };

  return (
    <>
      <div className={`menu-wrapper-find-object ${Animation}`} id="find-object-search-panel-wrapper" style={{ position: "absolute", zIndex: 2 }}>
        <div id="find-object-search-panel" className="find-object-search-panel position-relative">
          <div className="search-panel-find-object">
            <div id="back-to-find-object-list" className="back-to-find-object-list" onClick={ ()=>setAnimation(AnimationTypes.ShiftRight)}>&#8617;</div>
            <input type="text" id="find-object-search-panel-text-box" placeholder={placeholder} className="form-input" maxLength={256} value={inputValue} onChange={(e) => setInputValue(e.target.value)} onKeyDown={handleKeyDown}/>
            <button id="find-object-search-panel-find-button" type="button" className="app-button" onClick={handleFindClick}>
              <span className="ui-button-text">Find</span>
            </button>
          </div>
          {showError && (
          <div id="error-message" className="field-validation-error find-object-error-message" style={{ display: "block" }}>
            Please provide some data to find with.
          </div>
          )}
        </div>
      </div>
     
    </>
  );
};

export default FindSearchPanel;